import React from 'react';
import PropTypes from 'prop-types';

import { Flex } from '@ubisend/pulse-components';
import { FullPage } from '@ubisend/pulse-volt';

const FullPageDemo = ({ isPublic = false }) => (
  <Flex middle relative style={{ zIndex: 0 }} grow data-testid="full-page-demo">
    <FullPage start="/window/body/messages" isDemo={!isPublic} />
  </Flex>
);

FullPageDemo.propTypes = {
  isPublic: PropTypes.bool,
};

export default FullPageDemo;
